<div class="alert alert-error" *ngIf="notifications.length > 0" [ngClass]="{ 'alert-error--invert': invert }">
    <ul>
        <li *ngFor="let message of notifications">
            <svg class="svg-icon svg-icon--xs svg-icon--dark"><use href="assets/icons-ui.svg#cross-closed"></use></svg>
            <span [innerHTML]="message.message_content"></span>
        </li>
    </ul>
</div>

<div class="alert alert-error" *ngIf="errorNotifications.length > 0" [ngClass]="{ 'alert-error--invert': invert }">
    <ul>
        <li *ngFor="let notification of errorNotifications">
            <svg class="svg-icon svg-icon--xs svg-icon--dark"><use href="assets/icons-ui.svg#cross-closed"></use></svg>
            <span [innerHTML]="notification.message"></span>
        </li>
    </ul>
</div>
